var exports = {
  "y_": "xaf9ae18d--6b528d--pin",
  "ag": "xaf9ae18d--6b528d--balloon",
  "q9": "xaf9ae18d--6b528d--price",
  "U9": "xaf9ae18d--6b528d--count",
  "zx": "xaf9ae18d--6b528d--point",
};

module.exports = exports;
